import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const RATING_ENDPOINTS = {
  V1: createEndpoints('v1', {
    QUALITY_CONTROL_REVIEW: '/quality-control-review/',
    QUALITY_CONTROL_REVIEW_BY_ORDER: (orderID: number) => `/quality-control-review/${orderID}/`,
    ADMIN_CUSTOMER_REVIEW: (orderID: number) => `/admin-customer-review/${orderID}/`,
    INSPECTOR_OVERALL_RATING: (orderID: number) => `/inspector-overall-rating/${orderID}`,
    ADMIN_CUSTOMER_REVIEW_CAN_ADD: (orderID: number) => `/admin-customer-review/${orderID}/can-add-review/`,
    QUALITY_CONTROL_REVIEW_CAN_ADD: (orderID: number) => `/quality-control-review/${orderID}/can-add-review/`,
  }),
} as const;
